import { ReactNode } from "react";
import { Typography } from "@progress/kendo-react-common/dist/es/typography/Typography";

function GroupHeadline({ children }: { children?: ReactNode }) {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <Typography.h2 style={{ paddingBottom: "0.5rem" }}>
      {children}
    </Typography.h2>
  );
}

export default GroupHeadline;
